{
  "markread": "Märgi loetuks",
  "newest": "Uued",
  "unread": "Mitteloetud",
  "starred": "Tärniga",
  "tags": "Sildid",
  "alltags": "Kõik sildid",
  "timestamp": "lisatud {0,date} kell {0,time}",
  "hours": "lisatud {0,plural,one {1 tund},other {# tundi}} tagasi",
  "minutes": "lisatud {0,plural,one {1 minut},other {# minutit}} tagasi",
  "seconds": "lisatud {0,plural,one {1 sekund},other {# sekundit}} tagasi",
  "star": "Lisa tärn",
  "unstar": "Eemalda tärn",
  "mark": "Märgi loetuks",
  "unmark": "Märgi mitteloetuks",
  "load_img": "Laadi pildid",
  "open_window": "Ava",
  "searchbutton": "Otsi",
  "sources": "Tellimused",
  "source_add": "Lisa tellimus",
  "source_opml": "või impordi opml-fail või Google Reader",
  "source_export": "ekspordi tellimused",
  "source_edit": "Muuda",
  "source_delete": "Kustuta",
  "source_warn": "Kas tõesti kustutame tellimuse?",
  "source_new": "Uus salvestamata tellimus",
  "source_title": "Nimi",
  "source_tags": "Sildid",
  "source_comma": "komaga eraldatud",
  "source_select": "Tellimuse allika liik",
  "source_type": "Liik",
  "source_save": "Salvesta",
  "source_cancel": "Loobu",
  "source_saved": "Salvestatud",
  "no_entries": "Ühtki sündmust ei leitud",
  "more": "rohkem",
  "login": "Logi sisse",
  "login_username": "Kasutajanimi",
  "login_password": "Salasõna",
  "no_title": "Nimeta",
  "settingsbutton": "Seadistused",
  "filter": "Filtreeri",
  "share_diaspora_label": "Jaga Diaspora vahendusel",
  "logoutbutton": "Logi välja",
  "streamerror": "Ühtegi kirjet pole laaditud, kas laadime uuesti?",
  "share_mastodon_label": "Jaga Mastodoni võrgus",
  "share_wordpress_label": "Jaga WordPressis",
  "share_native_label": "Jaga",
  "offline_navigation_unavailable": "Vallasrežiimis ei saa hetkel silte ja tellimusi vahetada.",
  "source_deleting": "Kustutame tellimuse…",
  "error_edit_source": "Tellimuse muudatuste salvestamine ei õnnestunud:",
  "login_in_progress": "Proovime sisselogida…",
  "error_mark_items": "Kõikide nähtavate kirjete märkimine ei õnnestu:",
  "error_session_expired": "Sessioon on aegunud",
  "error_load_tags": "Siltide laadimine ei õnnestunud:",
  "error_sync": "Viimaste muudatuste sünkroniseerimine serverist ei õnnestu:",
  "error_share_native": "Kirje jagamine ei õnnestu.",
  "close_entry": "Sulge",
  "sources_refreshed": "Tellimus on värskendatud",
  "experimental": "Katselised seadistused",
  "reload_list": "Laadi loend uuesti",
  "error_add_source": "Tellimuse lisamine ei õnnestunud:",
  "share_facebook_label": "Jaga Facebookis",
  "next": "Järgmine",
  "loginbutton": "Logi sisse",
  "share_wallabag_label": "Salvesta Wallabagi",
  "error_offline_storage_not_available": "Vallasrežiimis andmehoidla pole saadaval. Palun kontrolli, et sinu veebibrauser {0}toetab IndexedDB APIt{1} ja kui sa kasutad Google Chrome brauserit, siis sa ei vaata selfoss saiti privaatses režiimis.",
  "error_invalid_subsection": "Vigane alamlõik:",
  "error_configuration": "Seadistuste laadimine ei õnnestu.",
  "info_url_copied": "Aadress on kopeeritud lõikelauale.",
  "article_actions": "Tegevused",
  "article_reading_time": "Lugemiseks kulub {0} minutit",
  "online_count": "Serveris leidub kirjeid",
  "offline_count": "Kohalikus süsteemis leidub kirjeid",
  "searchremove": "Peida otsing",
  "source_filter": "Filtreeri",
  "source_autotitle_hint": "Nime automaatseks tuvastamiseks jäta tühjaks",
  "source_pwd_placeholder": "Pole muudetud",
  "login_invalid_credentials": "Vale kasutajanimi ja/või salasõna",
  "refreshbutton": "Värskenda tellimusi",
  "source_last_post": "Viimane nähtud postitus",
  "source_refresh": "Värskenda see tellimus",
  "login_offline": "Vallasrežiimis andmehoidla",
  "error": "Tekkis viga",
  "days": "lisatud {0,plural,zero {täna},one {eile},other {# päeva tagasi}}",
  "share_mail_label": "Jaga e-kirjaga",
  "share_copy_label": "Kopeeri link lõikelauale",
  "share_pocket_label": "Salvesta Pocketisse",
  "share_twitter_label": "Jaga Twitteris/X'is",
  "search_label": "Otsingusõna",
  "source_menu": "Täiendavad toimingud",
  "source_browse": "Sirvi",
  "source_warn_cancel_dirty": "Kas jätame muudatused salvestamata?",
  "source_params_loading": "Laadime parameetreid…",
  "source_saving": "Salvestame tellimuse muudatusi…",
  "sources_loading": "Laadime tellimustest andmeid…",
  "no_sources": "Ühtegi tellimust pole seadistatud.",
  "source_go_to_settings": "Ava seadistustes",
  "sources_leaving_unsaved_prompt": "Kas soovid lahkuda seadistustest ja jätta tellimuse muudatused salvestamata?",
  "error_delete_source": "Tellimuse kustutamine ei õnnestunud:",
  "error_unknown_source": "Tellimuse teadmata tunnus:",
  "error_refreshing_source": "Tellimuste värskendamine ei õnnestunud:",
  "tag_change_color_button_title": "Muuda värvi",
  "entries_loading": "Laadime kirjeid…",
  "login_error_generic": "Sisselogimine ei õnnestunud: {errorMessage}",
  "error_unauthorized": "Jätkamiseks palun {link_begin}logi sisse{link_end}.",
  "error_check_log_file": "Tekkis viga, palun vaata logifaili „{0}“.",
  "error_check_system_logs": "Tekkis viga, palun vaata süsteemi logifaile.",
  "error_unwritable_logs": "Logide salvestamine ei õnnestu.",
  "app_update": "selfoss on uuendatud, palun laadi uuesti",
  "app_reload": "Laadi uuesti",
  "error_unknown_tag": "Tundmatu silt:",
  "error_mark_item": "Kirje märkimine või märkimise eemaldamine ei õnnestu:",
  "error_star_item": "Kirje tärniga märkimine või märkimise eemaldamine ei õnnestu:",
  "error_logout": "Väljalogimine ei õnnestunud:",
  "error_loading": "Viga laadimisel:",
  "error_loading_stats": "Statistika laadimine ei õnnestu:",
  "error_saving_color": "Uue värvi salvestamine ei õnnestu:",
  "error_offline_storage": "Vallasrežiimis andmehoidla viga: {0}. Uuesti laadimine võib viga parandada. Lülitame vallasrežiimi esialgu välja.",
  "error_share_native_abort": "Kirje jagamine ei õnnestu - kas brauseris pole ühtegi jagamisviisi seadistatud või katkestasid jagamise."
}
